import { useKeycloak } from "@react-keycloak/web";
import { create } from "zustand";
import { getUsers } from "../api/users";
import { addUserToProject } from "../api/projects";

export const useUsersStore = create<UserStore>((set) => {
  return {
    users: [],
    pagination: {
      page: 0,
      size: 0,
      total: 0
    },
    setUsersPage: (projectUsersPageData: ProjectUsersInterface) => {
      set((state): any => ({
          pagination: {
            page: projectUsersPageData.page,
            size: projectUsersPageData.size,
            total: projectUsersPageData.total
          },
          users: [
            ...state.users,
            ...(Array.isArray(projectUsersPageData.results) ? projectUsersPageData.results : [])
          ]
        })
      )
    },
  };
});

export const useUsersPage = () => {
  const { keycloak: { token }} = useKeycloak();

  return {
    loadUsersPage: async (_page: number) => {
      if (!token) return;

      try {
      const setUsersPage = useUsersStore.getState().setUsersPage;
      const usersPage = await getUsers(token);
      setUsersPage(usersPage);
      return usersPage;
      } catch (error) {
        console.error('Error loading users page:', error);
        // Return empty response to prevent crashes
        return { results: [], page: 0, size: 0, total: 0 };
      }
    },
    addUserToProject: async (project_id: string, user_data:ProjectUserInterface) => {
      if (!token) return;
console.log(user_data)
      await addUserToProject(token, project_id, user_data.id, user_data);
    }
  }
}
